export default {
  DESKTOP: 992,
  TABLET: 768,
  PHONE: 540,
};

export const MINH = 360;
export const MINLH = 440;
export const MINXLH = 560;
